import api from './api';
import {
  AssignmentSubmissionResult,
  SubmitAssignmentPayload,
} from '../types/assignment';

interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
}

const redirectToLogin = () => {
  window.location.href = '/login';
};

export const submitAssignment = async (
  payload: SubmitAssignmentPayload
): Promise<AssignmentSubmissionResult> => {
  try {
    const response = await api.post<ApiResponse<AssignmentSubmissionResult>>(
      '/api/Assignment/submit',
      payload
    );

    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.message || 'فشل في إرسال الواجب');
    }

    return response.data.data;
  } catch (error: unknown) {
    if (error && typeof error === 'object' && 'response' in error) {
      const axiosError = error as {
        response?: { status?: number; data?: { message?: string } };
      };
      if (axiosError.response?.status === 401) {
        redirectToLogin();
        throw new Error('غير مصرح لك بإرسال الواجب');
      }
      throw new Error(
        axiosError.response?.data?.message || 'فشل في إرسال الواجب'
      );
    }
    if (error instanceof Error) throw error;
    throw new Error('فشل في إرسال الواجب');
  }
};
